/**
 * TanStack Query hooks for `igaming-brands`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingBrandsQueryKeys,
	type CreateIgamingBrandsBody,
	type ListIgamingBrandsResponse,
	type IgamingBrandsRow,
} from "./api";

export function useIgamingBrandsList(): UseQueryResult<ListIgamingBrandsResponse, Error> {
	return useQuery({
		queryKey: igamingBrandsQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingBrandsCreate(): UseMutationResult<IgamingBrandsRow, Error, CreateIgamingBrandsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBrandsQueryKeys.all });
		},
	});
}

export function useIgamingBrandsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBrandsQueryKeys.all });
		},
	});
}
